export const LIST_EVENTS = Object.freeze({
  UPDATE_CHAPTER: 'update-chapter',
  UPDATE_EXAM: 'update-exam',
  UPDATE_LIST: 'update-list',
  FILE_UPLOAD_PROGRESS: 'file-upload-progress',
});
